import { OrgAdminConstants } from '../../../_constants';

const initialState = { removeOrgTeamLoading: true, data: '', error: false };

export function removeOrgTeamReducer(state = initialState, action) {
    
    switch (action.type) {
        case OrgAdminConstants.REQUEST_REMOVE_ORG_TEAM:
            return {
                removeOrgTeamLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_REMOVE_ORG_TEAM:
            return {
                removeOrgTeamLoading: false,
                data: action.getOrgTeam,
                error: false
            };
        case OrgAdminConstants.REMOVE_ORG_TEAM_ERROR:
            return {
                removeOrgTeamLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/OrgTeam/removeOrgTeam.reducer.js